import { Directive, ElementRef, Renderer2, HostListener, AfterViewInit } from "@angular/core";

@Directive({
  selector: '[appResponsiveImage]',
  standalone: true
})
export class ResponsiveImageDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener("window:resize")
  onResize(): void {
    this.updateImageClass();
  }

  ngAfterViewInit(): void {
    this.updateImageClass();
  }

  private updateImageClass(): void {
    const img = this.el.nativeElement as HTMLImageElement;
    const workElement = img.closest(".work__element")

    if (workElement?.classList.contains("layout__gryfy")) {
      if (window.innerWidth < 1550) {
        this.renderer.removeClass(img, "work__img");
      } else {
        this.renderer.addClass(img, "work__img");
      }
    }
    if (workElement?.classList.contains("layout__medal")) {
      if (window.innerWidth < 1100) {
        this.renderer.removeClass(img, "work__img");
      } else {
        this.renderer.addClass(img, "work__img");
      }
    }
    if (workElement?.classList.contains("layout__portret")) {
      if (window.innerWidth < 900) {
        this.renderer.removeClass(img, "work__img");
      } else {
        this.renderer.addClass(img, "work__img");
      }
    }
    if (workElement?.classList.contains("layout__zakopane")) {
      if (window.innerWidth < 1500) {
        this.renderer.removeClass(img, "work__img");
      } else {
        this.renderer.addClass(img, "work__img");
      }
    }
  }
}
